import { render } from "./InterestRegistration.vue?vue&type=template&id=357ba01f&scoped=true"
import script from "./InterestRegistration.vue?vue&type=script&lang=js"
export * from "./InterestRegistration.vue?vue&type=script&lang=js"

import "./InterestRegistration.vue?vue&type=style&index=0&id=357ba01f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357ba01f"]])

export default __exports__